import React from 'react'
import BarBase, { BarProps, BarType } from './BarBase'
import './BarSuccess'

function BarWarning(props: BarProps) {
  return (
   <BarBase {...props} type={BarType.Warning} />
  )
}

export default BarWarning
